export const RequestState = {
    INITIAL: "INITIAL",
    LOADING: "LOADING",
    SUCCESS: "SUCCESS",
    ERROR: "ERROR"
}